import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { GetPlannedSurveyByIDKey } from '../queries/useGetPlannedSurveyByID';
import { GetScheduledSurveysCacheKey } from '../queries/useGetPlannedSurveys';

export const deletePlannedSurvey = async (teamId: number, surveyId: number) => {
  return axios.delete(`/api/schedule-surveys/${teamId}/${surveyId}`);
};

export const useDeletePlannedSurvey = (teamId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ teamId, surveyId }: { teamId: number; surveyId: number }) =>
      deletePlannedSurvey(surveyId, teamId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GetScheduledSurveysCacheKey.ScheduledSurveys, teamId],
      });
    },
  });
};
